import React from 'react';

function Resume() {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h1 className="hero-title">Professional Resume</h1>
        <p className="hero-subtitle">Experience, Skills & Certifications</p>
      </div>

      <div className="content-section">
        {/* Download Section */}
        <div className="card">
          <div className="resume-download">
            <p className="text-content">
              Download my complete resume for detailed information about my professional 
              experience, technical skills, and certifications.
            </p>
            <button 
              className="download-btn" 
              onClick={() => {
                const link = document.createElement('a');
                link.href = '/resume.pdf';
                link.download = 'Rob_Higareda_Resume.pdf';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            >
              <svg className="download-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              Download PDF Resume
            </button>
          </div>
        </div>

        {/* Professional Summary */}
        <div className="card">
          <h2 className="section-title">Professional Summary</h2>
          <p className="text-content">
            Cloud Architect and Security Leader with 24+ years of experience spanning 
            enterprise infrastructure, cloud security, and large-scale compliance frameworks. 
            CISSP-certified since 2009 with 8 AWS certifications including Solutions Architect 
            Professional, Security Specialty, and Advanced Networking Specialty. Active Top Secret 
            security clearance. Proven track record architecting secure, compliant cloud solutions 
            at global scale for DoD, Federal, and enterprise customers. Author of the AWS DISA SCCA 
            framework and FedRAMP Rev5 Secure Configuration Guidance. Former Amazon Bar Raiser with a 
            passion for mentoring engineers and scaling technical impact through AI-driven tooling 
            and cross-organizational leadership.
          </p>
        </div>

        {/* Certifications with Real Badges */}
        <div className="card">
          <h2 className="section-title">Professional Certifications</h2>
          <div className="cert-badges-grid">
            <div className="cert-badge-item">
              <img 
                src="https://images.credly.com/images/6eeb0a98-33cb-4f72-bfc3-f89d65a3286c/image.png" 
                alt="CISSP"
                className="cert-badge-img"
              />
              <h3 className="cert-badge-title">CISSP</h3>
              <p className="cert-badge-org">(ISC)²</p>
              <p className="cert-badge-year">Since 2009</p>
            </div>
            <div className="cert-badge-item">
              <img 
                src="https://images.credly.com/size/340x340/images/2d84e428-9078-49b6-a804-13c15383d0de/image.png" 
                alt="AWS Solutions Architect Professional"
                className="cert-badge-img"
              />
              <h3 className="cert-badge-title">Solutions Architect</h3>
              <p className="cert-badge-org">Professional</p>
              <p className="cert-badge-year">Since 2021</p>
            </div>
            <div className="cert-badge-item">
              <img 
                src="https://images.credly.com/size/340x340/images/53acdae5-d69f-4dda-b650-d02ed7a50dd7/image.png" 
                alt="AWS Security Specialty"
                className="cert-badge-img"
              />
              <h3 className="cert-badge-title">Security Specialty</h3>
              <p className="cert-badge-org">AWS Certified</p>
              <p className="cert-badge-year">Since 2022</p>
            </div>
            <div className="cert-badge-item">
              <img 
                src="https://images.credly.com/size/340x340/images/4d08274f-64c1-495e-986b-3143f51b1371/image.png" 
                alt="AWS Advanced Networking Specialty"
                className="cert-badge-img"
              />
              <h3 className="cert-badge-title">Advanced Networking</h3>
              <p className="cert-badge-org">Specialty</p>
              <p className="cert-badge-year">Since 2021</p>
            </div>
            <div className="cert-badge-item">
              <img 
                src="https://images.credly.com/size/340x340/images/0e284c3f-5164-4b21-8660-0d84737941bc/image.png" 
                alt="AWS Solutions Architect Associate"
                className="cert-badge-img"
              />
              <h3 className="cert-badge-title">Solutions Architect</h3>
              <p className="cert-badge-org">Associate</p>
              <p className="cert-badge-year">Since 2019</p>
            </div>
            <div className="cert-badge-item">
              <img 
                src="https://images.credly.com/size/340x340/images/f0d3fbb9-bfa7-4017-9989-7bde8eaf42b1/image.png" 
                alt="AWS SysOps Administrator"
                className="cert-badge-img"
              />
              <h3 className="cert-badge-title">SysOps Administrator</h3>
              <p className="cert-badge-org">Associate</p>
              <p className="cert-badge-year">Since 2019</p>
            </div>
            <div className="cert-badge-item">
              <img 
                src="https://images.credly.com/size/340x340/images/00634f82-b07f-4bbd-a6bb-53de397fc3a6/image.png" 
                alt="AWS Cloud Practitioner"
                className="cert-badge-img"
              />
              <h3 className="cert-badge-title">Cloud Practitioner</h3>
              <p className="cert-badge-org">AWS Certified</p>
              <p className="cert-badge-year">Foundational</p>
            </div>
            <div className="cert-badge-item">
              <img 
                src="https://images.credly.com/images/4d4693bb-530e-4bca-9327-de07f3aa2348/image.png" 
                alt="AWS AI Practitioner"
                className="cert-badge-img"
              />
              <h3 className="cert-badge-title">AI Practitioner</h3>
              <p className="cert-badge-org">AWS Certified</p>
              <p className="cert-badge-year">Since 2024</p>
            </div>
          </div>
        </div>

        {/* Professional Experience */}
        <div className="card">
          <h2 className="section-title">Professional Experience</h2>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3 className="timeline-title">Principal Solutions Architect - AWS Security</h3>
                <p className="timeline-subtitle">Amazon Web Services | July 2025 - July 2026</p>
                <p className="timeline-description">
                  Leading security and compliance architecture within AWS Security Risk and Compliance, 
                  focusing on internal engineering impact across AWS services at global scale.
                </p>
                <ul className="timeline-list">
                  <li>Conducted comprehensive security analysis across 150+ AWS services for compliance alignment</li>
                  <li>Developed initial AI common controls framework bridging standard and AI compliance for AWS</li>
                  <li>Pioneered AI-driven documentation analysis engine adopted by AWS IAM team globally</li>
                  <li>Authored FedRAMP Rev5 Secure Configuration Guidance for AWS regulatory posture</li>
                  <li>Architected the DISA Secure Cloud Computing Architecture (SCCA) framework for DoD cloud adoption</li>
                  <li>Engineered CI/CD pipelines and generative AI tooling powering AWS global technical workshops</li>
                  <li>Standing member of design and documentation review boards for emerging AWS services</li>
                  <li>Partner with senior engineering directors and C-suite stakeholders on architectural standards</li>
                </ul>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3 className="timeline-title">Principal Specialist Solutions Architect</h3>
                <p className="timeline-subtitle">Amazon Web Services | September 2022 - July 2025</p>
                <p className="timeline-description">
                  Worked directly with US Federal, State, and Local Government customers on secure AWS 
                  adoption, focusing on Microsoft workloads, security, and compliance.
                </p>
                <ul className="timeline-list">
                  <li>Authored "Securing Windows Workloads on AWS Workshop" - first of its kind</li>
                  <li>Created AWS DISA SCCA framework published as AWS Prescriptive Guidance</li>
                  <li>Authored multiple public-facing cost optimization guides</li>
                  <li>Launched first AWS Activation Day for FSx for Windows</li>
                  <li>Led large-scale migration efforts moving hundreds of servers using AWS MGN</li>
                  <li>Created and hosted livestream content on AWS Twitch.tv channel</li>
                </ul>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3 className="timeline-title">Principal Technical Account Manager / Enterprise Support Lead</h3>
                <p className="timeline-subtitle">Amazon Web Services | January 2019 - September 2022</p>
                <p className="timeline-description">
                  Served as force multiplier within AWS Enterprise Support organization, working closely 
                  with leadership and cross-functional teams to build new programs, improve operational 
                  processes, and guide enterprise customers through large-scale modernization efforts.
                </p>
                <ul className="timeline-list">
                  <li>Led multi-year migration programs moving thousands of servers to VMware Cloud on AWS and cloud-native services</li>
                  <li>Delivered $3M+ in annual cost optimization through modernization and architectural improvements</li>
                  <li>Led team of 8-12 Technical Account Managers as Enterprise Support Lead</li>
                  <li>Became Amazon Bar Raiser — evaluated and hired 150+ new Amazonians</li>
                  <li>Mentored three TAMs to Principal-level promotions</li>
                  <li>Partnered with AWS Fraud, Professional Services, and Office of the CISO on security initiatives</li>
                  <li>Developed event-driven, scalable security approach with auto-mitigations for Media & Entertainment customer</li>
                  <li>Organized career hiring event that resulted in 8 new hires to the team</li>
                </ul>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3 className="timeline-title">Global Senior IT Systems Engineer</h3>
                <p className="timeline-subtitle">TaskUS | June 2018 - January 2019</p>
                <p className="timeline-description">
                  Worked with global IT teams to ensure operational stability across multiple 
                  international sites in the US, Mexico, Philippines, and Taiwan.
                </p>
                <ul className="timeline-list">
                  <li>Designed new reference architecture reducing costs by $40K per site through improved AD design and virtualization</li>
                  <li>Administered large ESXi clusters across 4 countries</li>
                  <li>Optimized AWS infrastructure deployments using EC2, ALB, and EBS</li>
                  <li>Developed and deployed company's global knowledge base system</li>
                  <li>Saved $24K annually by identifying cost-effective hosting provider</li>
                  <li>Worked with TaskUS security to improve corporate infosec policies</li>
                </ul>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3 className="timeline-title">Windows | Strategic Enterprise Architect</h3>
                <p className="timeline-subtitle">Rackspace Managed Hosting | August 2014 - June 2018</p>
                <p className="timeline-description">
                  Provided expert technical assistance bridging dedicated environments to cloud 
                  infrastructure including AWS, Azure, and Rackspace Cloud.
                </p>
                <ul className="timeline-list">
                  <li>Led technical infrastructure for $900K+ per month of company revenue</li>
                  <li>Negotiated 36% discount for customer through 36-month contract commitment</li>
                  <li>Mentored three people from Admin to Engineering roles</li>
                  <li>Established career growth programs pairing mentors with mentees</li>
                </ul>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3 className="timeline-title">Windows | Systems Administrator</h3>
                <p className="timeline-subtitle">Rackspace Managed Hosting | August 2013 - August 2014</p>
                <p className="timeline-description">
                  Provided fanatical support for enterprise customers including Windows Server 2003-2012 R2, 
                  Microsoft SQL Server, IIS, and additional Windows components.
                </p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3 className="timeline-title">Windows & Linux | Senior Systems Administrator</h3>
                <p className="timeline-subtitle">College of Public Health / University of Iowa | April 2001 - August 2013</p>
                <p className="timeline-description">
                  Lead Senior Systems Administrator responsible for all infrastructure design and 
                  implementation for collegiate and research environments.
                </p>
                <ul className="timeline-list">
                  <li>Implemented the college's first virtualized environment on Hyper-V, reducing physical space and power requirements</li>
                  <li>Set up isolated, air-gapped data systems with PGP and BitLocker for sensitive research projects</li>
                  <li>Co-created basis for CISO Office's campus-wide data retention and security policy</li>
                  <li>Sat on University-wide Active Directory Enterprise Administrations panel</li>
                  <li>Helped select and test university-wide VPN solution for pandemic preparedness</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Speaking Engagements */}
        <div className="card">
          <h2 className="section-title">Speaking Engagements</h2>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3 className="timeline-title">AWS re:Invent 2025</h3>
                <p className="timeline-description">Security and Compliance with Amazon EC2 Image Builder</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3 className="timeline-title">AWS DC Summit 2025</h3>
                <p className="timeline-description">Migrating VMware Workloads to AWS</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3 className="timeline-title">AWS DC Summit 2024</h3>
                <p className="timeline-description">Securing Windows Workshop</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3 className="timeline-title">AWS Show and Tell for Generative AI</h3>
                <p className="timeline-description">Host (2024-2025)</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3 className="timeline-title">AWS Supports You - Twitch.tv</h3>
                <p className="timeline-description">Host (2020-2023)</p>
              </div>
            </div>
          </div>
        </div>

        {/* Core Competencies */}
        <div className="card">
          <h2 className="section-title">Core Competencies</h2>
          <div className="skills-grid">
            <div className="skill-item">
              <span className="skill-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </span>
              <span>Cloud Security Architecture</span>
            </div>
            <div className="skill-item">
              <span className="skill-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/>
                  <line x1="16" y1="13" x2="8" y2="13"/>
                  <line x1="16" y1="17" x2="8" y2="17"/>
                  <polyline points="10 9 9 9 8 9"/>
                </svg>
              </span>
              <span>FedRAMP, PCI DSS & SOC 2</span>
            </div>
            <div className="skill-item">
              <span className="skill-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </span>
              <span>DISA SCCA & DoD Compliance</span>
            </div>
            <div className="skill-item">
              <span className="skill-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                  <line x1="8" y1="21" x2="16" y2="21"/>
                  <line x1="12" y1="17" x2="12" y2="21"/>
                </svg>
              </span>
              <span>Microsoft Workloads on AWS</span>
            </div>
            <div className="skill-item">
              <span className="skill-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                  <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/>
                </svg>
              </span>
              <span>Large-Scale Cloud Migrations</span>
            </div>
            <div className="skill-item">
              <span className="skill-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                  <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                  <path d="M2 17l10 5 10-5"/>
                  <path d="M2 12l10 5 10-5"/>
                </svg>
              </span>
              <span>Agentic AI & RAG Patterns</span>
            </div>
            <div className="skill-item">
              <span className="skill-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </span>
              <span>Technical Leadership & Mentoring</span>
            </div>
            <div className="skill-item">
              <span className="skill-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                  <line x1="12" y1="20" x2="12" y2="10"/>
                  <line x1="18" y1="20" x2="18" y2="4"/>
                  <line x1="6" y1="20" x2="6" y2="16"/>
                </svg>
              </span>
              <span>Cost Optimization ($3M+ delivered)</span>
            </div>
            <div className="skill-item">
              <span className="skill-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                  <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
                  <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
                  <line x1="12" y1="19" x2="12" y2="23"/>
                  <line x1="8" y1="23" x2="16" y2="23"/>
                </svg>
              </span>
              <span>Public Speaking & Technical Content</span>
            </div>
            <div className="skill-item">
              <span className="skill-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                  <polyline points="16 18 22 12 16 6"/>
                  <polyline points="8 6 2 12 8 18"/>
                  <line x1="14" y1="4" x2="10" y2="20"/>
                </svg>
              </span>
              <span>Infrastructure as Code</span>
            </div>
            <div className="skill-item">
              <span className="skill-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                  <circle cx="12" cy="12" r="3"/>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                </svg>
              </span>
              <span>Cross-Organizational Strategy</span>
            </div>
            <div className="skill-item">
              <span className="skill-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                  <polyline points="9 12 11 14 15 10"/>
                </svg>
              </span>
              <span>AI Security & Guardrails</span>
            </div>
          </div>
        </div>

        {/* Technical Skills */}
        <div className="card">
          <h2 className="section-title">Technical Skills</h2>
          <div className="tech-categories">
            <div className="tech-category">
              <h3 className="tech-category-title">AWS Services (7+ years)</h3>
              <div className="badge-container">
                <span className="badge aws">EC2 & Compute</span>
                <span className="badge aws">S3 & Storage</span>
                <span className="badge aws">VPC & Networking</span>
                <span className="badge aws">IAM & Security</span>
                <span className="badge aws">CloudFormation</span>
                <span className="badge aws">FSx for Windows</span>
                <span className="badge aws">AWS MGN</span>
                <span className="badge aws">RDS & EFS</span>
                <span className="badge aws">Storage Gateways</span>
                <span className="badge aws">Microsoft AD</span>
                <span className="badge aws">GuardDuty</span>
                <span className="badge aws">Security Hub</span>
              </div>
            </div>
            <div className="tech-category">
              <h3 className="tech-category-title">Security & Compliance (5+ years)</h3>
              <div className="badge-container">
                <span className="badge">CISSP</span>
                <span className="badge">FedRAMP</span>
                <span className="badge">DISA SCCA</span>
                <span className="badge">PCI DSS</span>
                <span className="badge">SOC 2</span>
                <span className="badge">NIST Frameworks</span>
                <span className="badge">DoD Security</span>
                <span className="badge">Risk Management</span>
                <span className="badge">AI Security & Guardrails</span>
              </div>
            </div>
            <div className="tech-category">
              <h3 className="tech-category-title">AI & Automation (3+ years)</h3>
              <div className="badge-container">
                <span className="badge">Agentic AI</span>
                <span className="badge">RAG Patterns</span>
                <span className="badge">Anthropic Claude</span>
                <span className="badge">Amazon Nova</span>
                <span className="badge">Generative AI</span>
                <span className="badge">CI/CD Pipelines</span>
                <span className="badge">Kiro IDE</span>
              </div>
            </div>
            <div className="tech-category">
              <h3 className="tech-category-title">Microsoft Technologies (20+ years)</h3>
              <div className="badge-container">
                <span className="badge">Windows Server</span>
                <span className="badge">Active Directory</span>
                <span className="badge">SQL Server 2012-2016</span>
                <span className="badge">IIS</span>
                <span className="badge">Hyper-V</span>
                <span className="badge">RDS</span>
                <span className="badge">DFS</span>
                <span className="badge">Azure Entra ID</span>
              </div>
            </div>
            <div className="tech-category">
              <h3 className="tech-category-title">Infrastructure & Virtualization (10+ years)</h3>
              <div className="badge-container">
                <span className="badge">VMware ESXi</span>
                <span className="badge">VMware Cloud on AWS</span>
                <span className="badge">Linux (NFS, SAMBA, SSH)</span>
                <span className="badge">Apache & MySQL</span>
                <span className="badge">Large-Scale Migrations</span>
              </div>
            </div>
          </div>
        </div>

        {/* Contact CTA */}
        <div className="card" style={{textAlign: 'center', background: 'linear-gradient(135deg, #2d3e50 0%, #1e2a3a 100%)', border: '1px solid rgba(100, 255, 218, 0.2)'}}>
          <h2 className="section-title" style={{color: '#64ffda'}}>Let's Work Together</h2>
          <p className="text-content" style={{marginBottom: '24px'}}>
            Interested in collaborating on cloud security, compliance, or AWS architecture projects? 
            I'm always open to discussing new opportunities and challenges.
          </p>
          <div className="contact-links">
            <a href="mailto:robert.higareda@gmail.com" className="contact-btn">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              Get In Touch
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Resume;
